
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurant/[id]",
      function () {
        return require("private-next-pages/restaurant/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurant/[id]"])
      });
    }
  